import axios from "axios"

export function allocateBudget(campaign_id, amount) {
    return axios.post(
        process.env.REACT_APP_API_HOST + '/campaign/balance/allocate/',
        {
            campaign_id: campaign_id,
            amount_e6_to_allocate: amount * 100000,
        },
        {
            headers: {
                'Authorization': localStorage.getItem('token'),
            }
        }
    )
}